import { createSelector } from 'reselect';
import { ArmyListUnitArsenalView } from '@Selectors/builder/view/ArmyListUnitArsenalView';
import { getCurrentArmyListUnit } from '@Selectors/builder/myArmyList/export/exportSelector';
import { getArmyListUnits } from '@Selectors/builder/myArmyList/make/unit/edit/selector/editSelector';
import { getArsenalArmy } from '@Selectors/arsenal/selector/getArsenalArmy';

export const ArmyListUnitArsenalPresenter = createSelector(
  [getCurrentArmyListUnit, getArmyListUnits, getArsenalArmy],
  (armyListUnit, armyListUnits, arsenalArmy): ArmyListUnitArsenalView => {
    if (!arsenalArmy || armyListUnits.length === 0) {
      return new ArmyListUnitArsenalView({
        count: 0,
        max: 0,
        unitName: '',
        armyId: '',
      });
    }

    const count = armyListUnits
      .filter((item) => item.unit_id === armyListUnit.unit_id)
      .map((item) => item.size)
      .reduce((a, b) => a + b, 0);

    const arsenalUnit =
      (arsenalArmy?.units ?? []).find((item) =>
        item.unitIds.includes(armyListUnit.unit_id),
      ) ?? null;

    return new ArmyListUnitArsenalView({
      count: count,
      max: 0,
      unitName: arsenalUnit?.name ?? '',
      armyId: arsenalArmy?.id ?? '',
    });
  },
);
